import $ from "jquery";
import React, { Component, useEffect } from "react";
import Draggable from "react-draggable";
import "./../../assets/css/CommentModel.css";

const CommentModel = ({
  children,
  title,
  backdrop,
  className,
  toggleModal = () => {
    alert();
  },
}) => {
  useEffect(() => {
    $(document).ready(function () {
      // document.getElementById("myModal").style.display = "block";
    });

    return () => {
      // document.getElementById("myModal").style.display = "none";
      // var modalContent = document.querySelector(".modal-content");
      // var minimizedModal = document.getElementById("minimizedModal");
      // modalContent.style.display = "none";
      // minimizedModal.style.display = "block";
      // var modalContent = document.querySelector(".modal-content");
      // var minimizedModal = document.getElementById("minimizedModal");
      // modalContent.style.display = "block";
      // minimizedModal.style.display = "none";
      // document.getElementById("myModal").style.display = "none";
    };
  }, []);
  return (
    <React.Fragment>
      <Draggable
        handle=".handle"
        defaultPosition={{ x: 0, y: 0 }}
        grid={[25, 25]}
        scale={1}
      >
        <div>
          
        <div
          className="hompagepopup"
        >
          {/* { <span id="openModalBtn" ></span> } */}
          <div id="myModal">
            <div className="modal-content mt-4">
              <div className="row">
                <div className="col-9 col-md-10 handle">
                  <h5>{title}</h5>
                </div>
                <div className="col-2 col-md-2 text-right">
                  <span
                    id="minimizeBtn1"
                    className="px-2 cancel-button rounded text-white cursor-pointer"
                    onClick={() =>
                      (document.getElementById("myModal").style.display =
                        "none")
                    }
                  >
                    -
                  </span>
                  <span
                    className="px-2 cancel-button rounded text-white cursor-pointer"
                    onClick={toggleModal}
                  >
                    &times;
                  </span>
                </div>
              </div>

              <div className="modal-header pt-1 pb-0"></div>
              <div className="modal-body">{children}</div>
            </div>

            {/* <div id="minimizedModal" className="minimized-modal text-center">
      <span id="restoreBtn">+</span>
    </div> */}
          </div>
        </div>
        </div>
      </Draggable>
      {/* <ExternalScriptComponent /> */}
    </React.Fragment>
  );
};

class ExternalScriptComponent extends Component {
  componentDidMount() {
    const body = document.querySelector("body");
    const script = document.createElement("script");
    script.setAttribute("src", "./../../../Script.js");
    script.defer = true;
    script.type = "text/javascript";
    body.appendChild(script);
  }

  render() {
    return <React.Fragment></React.Fragment>;
  }
}



export { ExternalScriptComponent };
export default CommentModel;
